import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useHover, useActive } from 'react-native-web-hooks';
import styled from 'styled-components/native';
import Text from '../text';
import Colors from '../colors';
const StyledPressable = styled.Pressable`
  justify-content: center;
`;
const Types = ['active', 'default'];
const color = {
  default: {
    text: Colors.gray200,
    hoverText: Colors.gray300,
    hoverBackgroundColor: Colors.lightGray300,
    activeText: Colors.gray400,
    activeBackgroundColor: Colors.lightGray300
  },
  active: {
    text: Colors.advanceBlue400
  }
};
export default function TabBtn(props) {
  const type = Types.includes(props.type) ? props.type : TabBtn.defaultProps.type;
  const ref = useRef();
  const isHovered = useHover(ref);
  const isActive = useActive(ref);
  const hoverStyle = {
    color: color[type].hoverText,
    backgroundColor: color[type].hoverBackgroundColor
  };
  const activeStyle = {
    color: color[type].activeText,
    backgroundColor: color[type].activeBackgroundColor
  };
  return /*#__PURE__*/React.createElement(StyledPressable, {
    style: [styles.button, styles[type], type !== 'active' && isHovered && !props.disabled && hoverStyle, type !== 'active' && isActive && !props.disabled && activeStyle, props.disabled && styles.disabled],
    ref: ref,
    disabled: props.disabled,
    onPress: props.onPress
  }, /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "medium",
    color: color[type].text,
    style: [type !== 'active' && isHovered && !props.disabled && hoverStyle, type !== 'active' && isActive && !props.disabled && activeStyle, styles.textHeight]
  }, props.children));
}
TabBtn.propTypes = {
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onPress: PropTypes.func,
  children: PropTypes.string
};
TabBtn.defaultProps = {
  type: 'default',
  disabled: false,
  onPress: () => {},
  children: ''
};
const styles = {
  button: {
    borderRadius: 20,
    overflow: 'hidden',
    height: 42,
    minWidth: 58,
    padding: 16,
    alignSelf: 'flex-start',
    backgroundColor: Colors.lightGray200,
    justifyContent: 'center',
    alignItems: 'center'
  },
  disabled: {
    opacity: 0.4
  },
  textHeight: {
    lineHeight: 25.6
  }
};
//# sourceMappingURL=tab.js.map